import React, { useEffect, useState } from 'react';
import { Redirect } from "react-router-dom";
import { useCoverLetter } from '../../context/CoverLetterContext';
import { COVERLETTER_FINALIZE, DASHBOARD_LINK, POPUP_TYPES } from '../../constants/constants';
import '../../assets/scss/app/cover-letter-screens/on-bording-screens.scss';
import WpAPI from '../../WpApi';
import ExperienceForm from './QuesAnsSections/ExperienceForm';
import FinalJobDetailsForm from './QuesAnsSections/FinalJobDetailsForm';
import SkillsForm from './QuesAnsSections/SkillsForm';
import StrengthsForm from './QuesAnsSections/StrengthsForm';
import WorkHistoryForm from './QuesAnsSections/WorkHistoryForm';
import WorkStyleForm from './QuesAnsSections/WorkStyleForm';
import PageLoader from '../common/PageLoader';
import SaveIcon from '../../assets/images/save-icon-brown.svg';
import { usePopup } from '../../context/PopupContext';

const Personalize = (props) => {
  const [back, setBack] = useState(false);
  const [next, setNext] = useState(false);
  const [isExperienceActive, setIsExperienceActive] = useState(false);
  const [isJobDetailActive, setIsJobDetailActive] = useState(false);
  const [isSkillsActive, setIsSkillsActive] = useState(false);
  const [isStrangthsActive, setIsStranghtsActive] = useState(false);
  const [isJobTitleActive, setIsJobTitleActive] = useState(false);
  const [isWorkStyleActive, setIsWorkStyleActive] = useState(false);
  const [redirect2, setRedirect2] = useState(null);
  const [formdata, setFormData] = useState({})
  const popup = usePopup();
  const {
    ques_ans_response,
    qa_steps_initiated,
    created_date,
    from,
    to,
    summary,
    generated_count,
    handlers: {
      save,
      update2Preview,
      editInProgress,
      loadLetter

    },
  } = useCoverLetter();

  const saveForm = () => {
    if(formdata.job_details_provided == false){
      //Required cleanup
      formdata.desired_company = ''
      formdata.desired_position = ''
      formdata.skills = []
    }
    update2Preview({ ques_ans_response: { ...formdata } }, true);
  }
  useEffect(() => {
    //browser issue, page not opening at top
    window.scrollTo(0, 0)
    // to handle if this is used to show popup and unhandled cases arises because of back button usages
    localStorage.removeItem('clickAction')
  }, []);
  useEffect(() => {
    if (next) {
      setRedirect2(COVERLETTER_FINALIZE);
      saveForm()

    }
    back && setRedirect2(COVERLETTER_FINALIZE)
  }, [next, back]);

  useEffect(() => {
    editInProgress() && !qa_steps_initiated && !created_date && loadLetter()
    qa_steps_initiated && saveLocally({...ques_ans_response})
  }, [qa_steps_initiated, created_date]);

  useEffect(() => {
    popup.configurePopup(POPUP_TYPES);
}, []);
  if (redirect2) return <Redirect to={redirect2} />
  if (!WpAPI.isLoggedIn()) return <Redirect to={DASHBOARD_LINK} />
  const saveLocally = (data) => {
    const d = { ...formdata, ...data }
    setFormData({ ...d })
  }

  const generateBodythruAI = () => {
    popup.show('wait')
    WpAPI.getLetterByAI(formdata).then(resp => {
        const op = replaceDummy(resp.output)
        update2Preview({ generated_count: generated_count + 1, summary: { ...summary, content: op } }, true)
        save()
        popup.close('wait')

    }).catch((e) => {
        popup.close('wait')
        popup.show('aiwarning', null, () => generateBodythruAI())
    });
    const replaceDummy = (c) => {
        from.fname.length && (c = c.replace('[Your Name]', from.fname))
        to.fname.length && (c = c.replace("[Recipient's Name]", to.fname))
        return c
      }
  }
  return (<>
    {editInProgress() ? <div className="cover-screen-outer revisit-accordion-screen">
      <div className="screen-inner">
        <div className="block">
          <div className="block-header">
            <div className="header-row">
              <div className="header-col col-left">
                {/* <button className="round-btn no-round-btn" onClick={() => setBack(!back)}> <i className="arrow-bar-left"></i><span>Back</span></button> */}
              </div>
              <div className="header-col col-mid">
                <h1>Need to make some changes?</h1>
                <p>Edit your cover letter by selecting each section below</p>
              </div>
              <div className="header-col col-right">
                <button className="round-btn mr-25" onClick={() => setBack(!back)}><span>Cancel</span></button>
                <button className="round-btn active" onClick={
                  () => {
                    setNext(!next)
                    popup.show('cl_content_override', 
                    null,
                    () => {
                            popup.close('cl_content_override');
                            generateBodythruAI();
                    })
                }}>
                  {/* <i className="r-btn-icon"><SaveIcon /></i> */}
                  <span>Save</span></button>
              </div>
            </div>
          </div>
          <div className="revisit-accordion-panel">
            <div className="accordions panel-one">
              <div className="panel-head" onClick={() => setIsExperienceActive(!isExperienceActive)}>
                <div className="title-right"><i className={isExperienceActive ? 'icon-arrow icon-arrow-up-light' : 'icon-arrow icon-arrow-down-light'}></i></div>
                <h2>How many relevant years of experience do you have?</h2>
                <p>Relevant experience can include jobs, freelance contracts, internships, and volunteering.</p>
              </div>
              {isExperienceActive &&
                <div className="panel-body">
                  <ExperienceForm data={{ experience: formdata.experience }} save={(data) => saveLocally(data)} />
                </div>}
            </div>
            <div className="accordions panel-two">
              <div className="panel-head" onClick={() => setIsJobDetailActive(!isJobDetailActive)}>
                <div className="title-right"><i className={isJobDetailActive ? 'icon-arrow icon-arrow-up-light' : 'icon-arrow icon-arrow-down-light'}></i></div>
                <h2>Are you applying for a specific job?</h2>
                <p className="job-para">We'll customize your cover letter with the job title and employer if you specify a job. If you don't specify a job, we'll create a cover letter you can customize later.</p>
              </div>
              {isJobDetailActive &&
                <FinalJobDetailsForm data={{ ...formdata }} save={(data) => {
                  saveLocally(data)
                  setIsSkillsActive(false)
                }} />
              }
            </div>
            {formdata.job_details_provided && formdata.desired_position.trim().length > 0 && <div className="accordions panel-three">
              <div className="panel-head" onClick={() => setIsSkillsActive(!isSkillsActive)}>
                <div className="title-right"><i className={isSkillsActive ? 'icon-arrow icon-arrow-up-light' : 'icon-arrow icon-arrow-down-light'}></i></div>
                <h2>What are your best skills?</h2>
                <p>We'll highlight skills in your cover letter to show you're a good fit for the job.</p>
              </div>
              {isSkillsActive &&
                <div className="panel-body">
                  <div className="panel-skill">
                    <SkillsForm data={{ ...formdata, qa_steps_initiated }} save={(data) => {saveLocally(data)}}  />
                  </div>
                </div>}
            </div>}
            <div className="accordions panel-four">
              <div className="panel-head" onClick={() => setIsStranghtsActive(!isStrangthsActive)}>
                <div className="title-right"><i className={isStrangthsActive ? 'icon-arrow icon-arrow-up-light' : 'icon-arrow icon-arrow-down-light'}></i></div>
                <h2>What makes you stand out?</h2>
                <p>Select your best strengths and soft skills to highlight in your cover letter.</p>
              </div>
              {isStrangthsActive &&
                <div className="panel-body">
                  <div className="panel-skill">
                    <StrengthsForm data={{ strengths: formdata.strengths }} save={(data) => saveLocally(data)} />
                  </div>
                </div>}
            </div>
            <div className="accordions panel-five">
              <div className="panel-head" onClick={() => setIsJobTitleActive(!isJobTitleActive)}>
                <div className="title-right"><i className={isJobTitleActive ? 'icon-arrow icon-arrow-up-light' : 'icon-arrow icon-arrow-down-light'}></i></div>
                <h2>What's your relevant job experience?</h2>
                <p>Select a recent job that's relevant to the position you're applying for.</p>
              </div>
              {isJobTitleActive &&
                <div className="panel-body">
                  <div className="screen-previous">
                    <WorkHistoryForm data={{ work_history: formdata.work_history }} save={(data) => saveLocally(data)} />
                  </div>
                </div>}
            </div>
            <div className="accordions panel-six">
              <div className="panel-head" onClick={() => setIsWorkStyleActive(!isWorkStyleActive)}>
                <div className="title-right"><i className={isWorkStyleActive ? 'icon-arrow icon-arrow-up-light' : 'icon-arrow icon-arrow-down-light'}></i></div>
                <h2>How do you prefer to work?</h2>
                <p>We'll personalize the tone of your letter based on your working style.</p>
              </div>
              {isWorkStyleActive &&
                <div className="panel-body">
                  <div className="panel-work-style">
                    <WorkStyleForm data={{ work_style: formdata.work_style }} save={(data) => saveLocally(data)} />
                  </div>
                </div>}
            </div>
          </div>
        </div>
      </div>
    </div> : <PageLoader />} </>
  );
}

export default Personalize;